var React = require('react');

function Input (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("polygon",{"points":"14.2,20.4 12.8,19 18,13.9 12.8,8.7 14.2,7.3 20.8,13.9 ","key":1}),React.createElement("rect",{"x":"2","y":"13","width":"17","height":"2","key":2}),React.createElement("polygon",{"points":"27,25 5,25 5,18 7,18 7,23 25,23 25,5 7,5 7,10 5,10 5,3 27,3 ","key":3})]);
}

Input.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28 28","style":{"enableBackground":"new 0 0 28 28"},"xmlSpace":"preserve"};

module.exports = Input;

Input.default = Input;
